<template>
  <div class="form-group"
       :class="[
       {'input-group': hasIcon},
       {'has-danger': error},
       {'input-group-focus': focused},
       {'has-label': label || $slots.label},
       {'has-success': !error && touched}]">
    <slot name="label">
      <label v-if="label" :class="labelClasses">
        {{label}}
        <span v-if="required">*</span>
      </label>
    </slot>

    <slot name="addonLeft">
      <div v-if="addonLeftIcon" class="input-group-addon input-group-prepend">
        <i :class="addonLeftIcon"></i>
      </div>
    </slot>
    <slot>
      <input
        ref="input"
        v-bind:value="value"
        v-on="listeners"
        v-bind="$attrs"
        v-mask="masking"
        class="form-control noXButton webkit-stuff"
        v-bind:class="[{valid: value && !error}, inputClasses]"
        aria-describedby="addon-right addon-left">
    </slot>
    <slot name="addonRight">
        <span v-if="addonRightIcon" class="input-group-addon input-group-append">
          <i :class="addonRightIcon"></i>
        </span>
    </slot>

    <slot name="infoBlock"></slot>
    <slot name="helpBlock">
      <div class="text-danger invalid-feedback" style="display: block;" :class="{'mt-2': hasIcon}" v-if="error">
        {{ error }}
      </div>
    </slot>
  </div>
</template>
<script>
  export default {
    inheritAttrs: false,
    name: 'mask-input',
    props: {
      required: Boolean,
      label: String,
      error: String,
      labelClasses: String,
      inputClasses: String,
      value: [String, Number],
      addonRightIcon: String,
      masking: RegExp,
      type: Number,
      addonLeftIcon: String
    },
    data() {
      return {
        touched: true,
        focused: false,
      }
    },
    computed: {
      listeners() {
        return {
          ...this.$listeners,
          input: this.updateValue,
          focus: this.onFocus,
          blur: this.onBlur,
        }
      },
      hasIcon() {
        const {addonRight, addonLeft} = this.$slots;
        return addonRight !== undefined || addonLeft !== undefined || this.addonRightIcon !== undefined || this.addonLeftIcon !== undefined
      }
    },
    methods: {
      updateValue(evt) {
        let value = this.$refs.input.value

        if (!this.touched && value) {
          this.touched = true
        }
        let numberCount=0;
        for(let i=0;i< value.length;i++){
          if(!isNaN(value[i])){
            numberCount++;
          }
        }
        this.$emit('input', value)
      },
      formatValue: function (value) {
        if(this.$refs.input.value.indexOf("%") === -1){
          if(isNaN(this.$refs.input.value)){
            return ""
          }
          else if(this.$refs.input.value === "." | this.$refs.input.value === "" | this.$refs.input.value === "%"){
            return "0.00%"
          }
          else{
            return this.$refs.input.value+"%"
          }
        }
        return this.$refs.input.value
      },
      onFocus(value){
        this.focused = true;
        this.$emit('focus', value);
      },
      onBlur(value){
        if(this.type === 4) {
          value = this.formatValue(value);
          this.$refs.input.value = value
        }
        else if(this.type !== 4){
          this.focused = false;
        }
        this.$emit('blur', value);
      }
    },
  }
</script>
<style>
  .noXButton::-ms-clear {
    width: 0;
    height: 0;
  }
  .webkit-stuff::-webkit-contacts-auto-fill-button {
    visibility: hidden;
  }
</style>
